"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _babelHelperVueJsxMergeProps = _interopRequireDefault(require("@vue/babel-helper-vue-jsx-merge-props"));
require("core-js/modules/es.array.push.js");
var _antDesignVue = require("ant-design-vue");
var _vue = _interopRequireDefault(require("vue"));
var _vueDraggableResizable = _interopRequireDefault(require("vue-draggable-resizable"));
var _utils = require("../utils");
// https://www.antdv.com/components/table-cn/

// https://www.npmjs.com/package/vue-draggable-resizable

_vue.default.component('vue-draggable-resizable', _vueDraggableResizable.default);
var _default = exports.default = {
  name: 'BasisTable',
  // 基础表格组件
  props: {
    ..._antDesignVue.Table.props,
    // 自定义属性 - v-model绑定的数据
    value: {
      type: Array,
      default: undefined
    },
    // 是否展示外边框和列边框
    bordered: {
      type: Boolean,
      default: false
    },
    // 表格列的配置描述
    // 包括table.column所有属性，另外新增了sort（用于排序）、tooltip（用于在表头显示tooltip文字提示）属性
    columns: {
      type: Array,
      default: () => []
    },
    // 数据数组
    dataSource: {
      type: Array,
      default: () => []
    },
    // 通过点击行来展开子行
    expandRowByClick: {
      type: Boolean,
      default: true
    },
    // 分页器 https://www.antdv.com/components/table-cn/#pagination。设为 false 时不展示和进行分页
    pagination: {
      type: [Object, Boolean],
      default: false
    },
    // 表格行 key 的取值，可以是字符串或一个函数
    rowKey: {
      type: [String, Function],
      default: 'id'
    },
    // 列表项是否可选择
    rowSelection: {
      type: Object,
      default: null
    },
    // 自定义属性 - 是否可选择 配合rowSelection使用，该值为false时，rowSelection及multiple无效
    selectable: {
      type: Boolean,
      default: false
    },
    // 自定义属性 - 是否支持多选，false时为单选。selectable为false时，该值无效
    multiple: {
      type: Boolean,
      default: true
    },
    scroll: {
      type: Object,
      default: undefined
    },
    // 表格大小
    size: {
      type: String,
      default: 'small',
      validator: value => ['default', 'middle', 'small'].includes(value)
    },
    // 自定义属性 - 是否可伸缩列
    scalable: {
      type: Boolean,
      default: true
    },
    // 自定义属性 - 数据为空时的提示语
    emptyDesc: {
      type: String,
      default: undefined
    },
    // 自定义属性 - 默认选中的行key，适用于只需要返回rowKey相应字段值的场景
    defaultSelectedRowKeys: {
      type: Array,
      default: () => []
    },
    // 自定义属性 - 默认选中的行，适用于需要返回行数据的场景
    defaultSelectedRows: {
      type: Array,
      default: () => []
    },
    // 自定义属性 - 超过宽度将自动省略，暂不支持和排序筛选一起使用。column.ellipsis的优先级高于该设置
    ellipsis: {
      type: Boolean,
      default: true
    },
    // 自定义属性 - 设置为true时，进行本地排序
    // ! 注意：这里是“sort”，不是“sorter”。column.sorter的优先级高于该设置
    sort: {
      type: Boolean,
      default: true
    },
    // 自定义属性 - 是否清除空值的children，避免出现没有下级时还显示“+”号。在接口返回的children为空数组时使用并设置为true
    clearEmptyChildren: {
      type: Boolean,
      default: false
    },
    // 自定义属性 - 用来标识行选中的列表
    selectedColumnName: {
      type: String,
      default: '_selected'
    }
  },
  data() {
    return {
      emptyImage: _antDesignVue.Empty.PRESENTED_IMAGE_SIMPLE,
      selectedRowKeys: [],
      selectedRows: [],
      targetDataSource: [],
      // 对dataSource进行初始化处理后的数据
      // 注意：当selectable为true时，targetRowSelection的所有选择事件都基于targetDataSourceRaw进行处理，否则会导致已选中的值，切换搜索条件后重新选择时覆盖旧值的问题
      targetDataSourceRaw: [],
      // 处理后的原始数据，用于筛选时恢复数据

      // 可控的排序 Begin
      sortedInfo: null,
      // 可控的排序 End
      // 可控的筛选 Begin
      filteredInfo: {},
      // filteredValue与dataIndex的映射关系，用于清空筛选状态
      searchTextMap: {},
      // dataIndex与搜索值的映射关系
      searchInput: null,
      expandedKeys: [] // 展开的行
      // 可控的筛选 End
    };
  },
  computed: {
    // 使用自定义插槽的列
    customScopeSlotsColumns() {
      const columns = this.columns;
      let newColumns = [];
      columns.forEach(element => {
        if (element.children) {
          newColumns = newColumns.concat(element.children);
        } else {
          newColumns.push(element);
        }
      });
      // this.columns = this.columns.concat()
      return newColumns.filter(item => item.scopedSlots && item.scopedSlots.customRender);
      // return this.columns.filter((item) => item.scopedSlots && item.scopedSlots.customRender)
    },
    // 覆盖默认的 table 元素
    targetComponents() {
      const _components = !this.scalable ? {} : {
        header: {
          cell: this.resizeableTitle
        }
      };
      return Object.assign({}, _components, this.components);
    },
    // 伸缩列映射关系
    draggingState() {
      // eslint-disable-next-line no-sequences
      const draggingMap = this.columns.reduce((map, node) => (map[node.key || node.dataIndex] = node && node.width, map), new Map());
      return _vue.default.observable(draggingMap);
    },
    // rowSelection具体的配置项: https://www.antdv.com/components/table-cn/#rowSelection
    targetRowSelection() {
      if (!this.selectable) {
        return null;
      }
      // 外部传入的和当前默认配置合并
      return Object.assign({}, {
        // 自定义列表选择框宽度
        columnWidth: 50,
        // 把选择框列固定在左边
        fixed: false,
        selectedRowKeys: this.selectedRowKeys,
        type: this.multiple ? 'checkbox' : 'radio',
        // 多选/单选，checkbox or radio
        // 选中项发生变化时的回调	Function(selectedRowKeys, selectedRows)
        onChange: this.onChange,
        // 用户手动选择/取消选择某列的回调 Function(record, selected, selectedRows, nativeEvent)
        onSelect: this.onSelect,
        // 用户手动选择/取消选择所有列的回调 Function(selected, selectedRows, changeRows)
        onSelectAll: this.onSelectAll,
        // 用户手动选择反选的回调 Function(selectedRows)
        onSelectInvert: this.onSelectInvert,
        // 选择框的默认属性配置
        getCheckboxProps: record => ({
          props: {
            disabled: record.disabled
          }
        })
      }, this.rowSelection);
    },
    // 展开的图标显示在哪一列，如果没有 rowSelection，默认显示在第一列，否则显示在选择框后面
    targetExpandIconColumnIndex() {
      const {
        expandIconColumnIndex,
        targetRowSelection
      } = this;
      if (expandIconColumnIndex === undefined && !_.isEmpty(targetRowSelection)) return 1;
      return expandIconColumnIndex;
    },
    // 行高
    trHeight() {
      const {
        size
      } = this;
      return {
        default: 54,
        middle: 46,
        small: 38
      }[size] || 38;
    },
    // 是否有children
    hasChildren() {
      const {
        dataSource,
        childrenColumnName
      } = this;
      return dataSource.some(item => childrenColumnName in item);
    },
    // 树形结构时的数据结构配置
    treeConfig() {
      const {
        rowKey,
        childrenColumnName
      } = this;
      return {
        id: rowKey,
        children: childrenColumnName
      };
    },
    // 对columns进行统一转换处理
    targetColumns() {
      const {
        ellipsis: globalEllipsis,
        sort: globalSort,
        columns,
        selectable,
        targetRowSelection,
        hasChildren,
        filteredInfo
      } = this;

      // 深拷贝防止改动源数据
      const _columns = columns.filter(column => {
        // 通过 column.show 判断是否显示该 column
        // hideInSetting - 通过列设置控制列的显隐
        if ((0, _utils.getType)(column.show) === 'function') {
          return column.show() !== false && column.hideInSetting !== true;
        }
        return column.show !== false && column.hideInSetting !== true;
      });

      // TODO: 实现宽度自适应
      // const totalWidth = _columns.reduce((pre, cur) => pre + Number(cur.width || 0), 0)
      // // 赋值width
      // let width = 0
      // if (totalWidth < tableWidth && _columns.length > 0) {
      //   // 16为checkbox表格的左右内边距
      //   const columnWidth = selectable ? targetRowSelection.columnWidth + 16 : 0
      //   width = (tableWidth - columnWidth) / _columns.length
      // }

      return _columns.map(column => {
        const {
          ellipsis,
          key,
          dataIndex,
          sort,
          sorter,
          filterable
        } = column;
        // 超过宽度显示省略号 column.ellipsis 优先级最高
        if (ellipsis === undefined && globalEllipsis === true) column.ellipsis = globalEllipsis;

        // 如果没有配置key属性，则把dataIndex的值赋给key。用于排序时提供给接口使用
        if (key === undefined) column.key = dataIndex || column.scopedSlots?.customRender;

        // column.sorter 排序函数，本地排序使用一个函数(参考 Array.sort 的 compareFunction)，需要服务端排序可设为 true
        // ! sort为自定义的属性，设置为true时，进行本地排序。column.sorter的优先级最高
        if ((sort === undefined && globalSort === true || sort === true) && sorter === undefined) {
          column.sorter = (a, b) => {
            if (a[dataIndex] === undefined) return 0;
            if ((0, _utils.getType)(a[dataIndex]) === 'number' || !isNaN(a[dataIndex])) return a[dataIndex] - b[dataIndex]; // 数字
            return a[dataIndex].localeCompare(b[dataIndex]); // 字符串
          };
        }

        // 自定义筛选菜单 - 通过设置 column.filterable = true 开启筛选功能，通过设置 column.filters 设置多选数组，不设置时使用文本框搜索
        if (filterable) {
          // 添加自定义插槽
          if (!(column.scopedSlots && column.scopedSlots.filterDropdown)) {
            column.scopedSlots = Object.assign(column.scopedSlots || {}, {
              filterDropdown: 'filterDropdown'
            });
          }
          if (!column.onFilter) {
            column.onFilter = (value, record) => {
              // 树形结构的筛选在handleSearch方法中实现
              if (!hasChildren) {
                // 被匹配的原始值
                const source = record[dataIndex]?.toString().toLowerCase();
                // 需要匹配的目标值
                const target = value.toString().trim().toLowerCase();
                return source && source.includes(target) || target && target.includes(source);
              }
              return true;
            };
            column.onFilterDropdownVisibleChange = visible => {
              if (visible && !column.filters) {
                setTimeout(() => {
                  this.searchInput && this.searchInput.focus();
                }, 200);
              }
            };
          }
        }

        // 用于清空筛选状态
        if (filterable || column.filters || column.onFilter) {
          filteredInfo[column.dataIndex] = filteredInfo[column.dataIndex] || null;
          column.filteredValue = filteredInfo[column.dataIndex];
        }

        // if (width) column.width = width

        return column;
      });
    }
  },
  watch: {
    value: {
      handler(val) {
        if (val !== undefined && !_.isEqual(val, this.selectedRowKeys)) {
          this.selectedRowKeys = val;
        }
      },
      immediate: true
    },
    defaultSelectedRowKeys: {
      handler(val) {
        if (val.length > 0) this.selectedRowKeys = val;
      },
      immediate: true
    },
    expandedRowKeys: {
      handler(val) {
        if (val) this.expandedKeys = val;
      },
      immediate: true
    },
    defaultSelectedRows: {
      handler(val, oldVal) {
        if (val.length > 0 && !_.isEqual(val, oldVal)) {
          this.selectedRows = val;
          this.selectedRowKeys = val.map(item => item[this.rowKey]);
          this.onChange(this.selectedRowKeys, val);
        }
      },
      immediate: true
    },
    selectedRowKeys: {
      handler(val) {
        // 回填默认选中值
        this.$emit('input', val);
      },
      immediate: true
    },
    dataSource: {
      handler(val, oldVal) {
        // 有数据且新旧值不同时进行格式转换
        if (!_.isEmpty(val) && !_.isEqual(val, oldVal)) {
          const {
            hasChildren,
            clearEmptyChildren
          } = this;
          if (hasChildren) {
            const {
              selectedColumnName,
              defaultSelectedRowKeys,
              treeConfig
            } = this;
            this.$m.tree.forEach(val, node => {
              // 清除空值children，解决出现children为空数组时仍然出现“+”号的问题
              const children = node[treeConfig.children] || undefined;
              if (clearEmptyChildren && _.isEmpty(children) && children !== undefined) {
                delete node[treeConfig.children];
              }
              // 回填默认选中值
              node[selectedColumnName] = defaultSelectedRowKeys.includes(node[treeConfig.id]) || node[selectedColumnName];
            }, treeConfig);
          }
          this.targetDataSource = val;
          this.targetDataSourceRaw = _.cloneDeep(val);
          if (hasChildren) this.updateSelectedResult();
        } else {
          this.targetDataSource = val;
          this.targetDataSourceRaw = _.cloneDeep(val);
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    handleTableChange(pagination, filters, sorter) {
      this.$emit('change', pagination, filters, sorter);
      this.filteredInfo = filters;
      this.sortedInfo = sorter;
    },
    // 刷新
    refresh() {
      this.$emit('refresh');
    },
    // 自定义表头为可伸缩
    resizeableTitle(h, props, children) {
      const {
        columns,
        draggingState
      } = this;
      let thDom = null;
      const {
        key,
        ...restProps
      } = props;
      const col = columns.find(_col => {
        const k = _col.key || _col.dataIndex;
        return k === key;
      }) || {};

      // 表头显示tooltip
      const tooltipDom = col.tooltip ? h("a-tooltip", {
        "scopedSlots": {
          title: () => h("span", {
            "domProps": {
              "innerHTML": col.tooltip
            }
          })
        }
      }, [h("a-icon", {
        "on": {
          "click": e => e.stopPropagation()
        },
        "class": "m-m-r-4",
        "attrs": {
          "type": "question-circle"
        }
      })]) : null;
      if (!col.width) {
        return h("th", (0, _babelHelperVueJsxMergeProps.default)([{}, restProps, {
          "class": col.tooltip ? 'basis-table-row-tooltip' : null
        }]), [tooltipDom, children]);
      }
      const onDrag = x => {
        draggingState[key] = 0;
        col.width = Math.max(x, 50); // 最小宽度为50
      };
      const onDragstop = () => {
        draggingState[key] = thDom.getBoundingClientRect().width;
      };
      const draggableWidth = 5;
      // onClick={(e) => e.stopPropagation()} 阻止事件冒泡，否则点击拖动时会触发单元格的排序事件
      return h("th", (0, _babelHelperVueJsxMergeProps.default)([{}, restProps, {
        "directives": [{
          name: "ant-ref",
          value: r => thDom = r
        }],
        "attrs": {
          "width": col.width
        },
        "class": col.tooltip ? 'resize-table-th basis-table-row-tooltip' : 'resize-table-th'
      }]), [tooltipDom, h("span", {
        "attrs": {
          "title": col.title
        }
      }, [children]), h("div", {
        "style": `width:${draggableWidth}px`,
        "on": {
          "click": e => e.stopPropagation()
        },
        "class": "table-draggable-handle"
      }, [h("vue-draggable-resizable", {
        "key": col.key,
        "class": "table-draggable-handle",
        "attrs": {
          "w": draggableWidth,
          "x": draggingState[key] || col.width,
          "z": 1,
          "axis": "x",
          "draggable": true,
          "resizable": false
        },
        "on": {
          "dragging": onDrag,
          "dragstop": onDragstop
        }
      })])]);
    },
    // ! 表格选择逻辑 Begin
    /**
     * @description: 选中项发生变化时的回调 注：供外部使用，不可修改名称和入参
     * @param {array} selectedRowKeys 返回跨页的选中值
     * @param {array} selectedRows 当前页选中的行
     */
    onChange(selectedRowKeys, selectedRows) {
      const {
        hasChildren,
        multiple
      } = this;

      // 非树形结构或单选
      if (!hasChildren || !multiple) {
        this.selectedRowKeys = selectedRowKeys;
        const tempRows = [...this.selectedRows, ...selectedRows];
        const curAllKeys = selectedRowKeys.map(key => ({
          [this.rowKey]: key
        }));
        // 跨页选中的所有行: 取交集，结果值是从第一数组中选择
        this.selectedRows = _.intersectionBy(tempRows, curAllKeys, this.rowKey);

        // 使用_.cloneDeep进行深拷贝，防止在rowSelectionChange事件中对selectedRowKeys和selectedRows进行修改时影响内部数据
        this.$emit('rowSelectionChange', {
          selectedRowKeys: _.cloneDeep(this.selectedRowKeys),
          selectedRows: _.cloneDeep(this.selectedRows)
        });
      }
    },
    // 用户手动选择/取消选择某列的回调 注：供外部使用，不可修改名称和入参
    async onSelect(record, selected, selectedRows, nativeEvent) {
      const {
        selectedColumnName,
        hasChildren,
        multiple,
        targetDataSourceRaw,
        treeConfig
      } = this;
      record[selectedColumnName] = selected;

      // 更改原始数据的选中状态
      const target = this.$m.tree.findNode(targetDataSourceRaw, node => node[treeConfig.id] === record[treeConfig.id], treeConfig);
      if (target) if (target) target[selectedColumnName] = selected;

      // 树形结构且多选
      if (hasChildren && multiple) {
        // 遍历选中或取消子节点
        await this.traverseChildren(record, selected);
        // 遍历选中或取消父节点
        await this.traverseParent(record);
        this.updateSelectedResult();
      }

      // console.log('rowSelectionSelect', record, selected, selectedRows)
      this.$emit('rowSelectionSelect', record, selected, selectedRows, nativeEvent);
    },
    // 用户手动选择/取消选择所有列的回调 注：供外部使用，不可修改名称和入参
    onSelectAll(selected, selectedRows, changeRows) {
      const {
        selectedColumnName,
        hasChildren,
        targetDataSourceRaw,
        treeConfig
      } = this;
      if (hasChildren) {
        changeRows.forEach(item => {
          // 更改原始数据的选中状态
          const target = this.$m.tree.findNode(targetDataSourceRaw, node => node[treeConfig.id] === item[treeConfig.id], treeConfig);
          if (target) target[selectedColumnName] = selected;
        });
        this.updateSelectedResult();
      }

      // console.log('rowSelectionSelectAll', selected, selectedRows, changeRows)
      this.$emit('rowSelectionSelectAll', selected, selectedRows, changeRows);
    },
    // 用户手动选择反选的回调 注：供外部使用，不可修改名称和入参
    onSelectInvert(selectedRows) {
      // console.log('rowSelectionSelectInvert', selectedRows)
      this.$emit('rowSelectionSelectInvert', selectedRows);
    },
    // 遍历选中或取消子节点
    traverseChildren(record = {}, selected = false) {
      const {
        selectedColumnName,
        treeConfig,
        targetDataSourceRaw
      } = this;
      const children = record[treeConfig.children] || [];
      return new Promise((resolve, reject) => {
        this.$m.tree.forEach(children, node => {
          node[selectedColumnName] = selected;

          // 更改原始数据的选中状态
          const target = this.$m.tree.findNode(targetDataSourceRaw, _node => _node[treeConfig.id] === node[treeConfig.id], treeConfig);
          if (target) target[selectedColumnName] = selected;
        }, treeConfig);
        resolve(children);
      });
    },
    // 获取某个节点的直属父级
    getNodeParent(targetNode) {
      const {
        targetDataSourceRaw,
        treeConfig
      } = this;
      const data = this.$m.tree.findPathAll(targetDataSourceRaw, node => node[treeConfig.id] === targetNode[treeConfig.id], treeConfig);
      const target = data[0] || [];
      return target.slice(-2, -1)[0] || {};
    },
    // 获取某节点下所有已选中的子节点
    getKeysForNode(record) {
      const {
        treeConfig,
        selectedColumnName
      } = this;
      const children = record[treeConfig.children];
      if (!_.size(children)) {
        return [];
      }
      // node[selectedColumnName] 的值可能是Boolean值或者0、1数字
      const data = this.$m.tree.findNodeAll(children, node => !!node[selectedColumnName], treeConfig);
      return data.map(item => item[treeConfig.id]);
    },
    // 遍历选中或取消父节点
    traverseParent(record = {}) {
      const {
        selectedColumnName,
        targetDataSourceRaw,
        treeConfig
      } = this;
      return new Promise((resolve, reject) => {
        const traverse = item => {
          if (!_.isEmpty(item)) {
            const selected = this.getKeysForNode(item).length > 0;
            item[selectedColumnName] = selected;

            // 更改原始数据的选中状态
            const target = this.$m.tree.findNode(targetDataSourceRaw, node => node[treeConfig.id] === item[treeConfig.id], treeConfig);
            if (target) target[selectedColumnName] = selected;
            const itemParent = this.getNodeParent(item);
            if (itemParent) {
              traverse(itemParent);
            }
          }
        };
        const recordParent = this.getNodeParent(record);
        traverse(recordParent);
        resolve(record);
      });
    },
    // 更新选择结果 注：供外部使用，不可修改名称和入参
    updateSelectedResult() {
      const {
        targetDataSourceRaw,
        selectedColumnName,
        treeConfig
      } = this;
      this.selectedRowKeys = this.getKeysForNode({
        [treeConfig.children]: targetDataSourceRaw
      });
      const selectedTree = this.$m.tree.filter(targetDataSourceRaw, node => Boolean(node[selectedColumnName]) === true, treeConfig);
      this.selectedRows = this.$m.tree.toList(selectedTree, treeConfig);
      // 使用_.cloneDeep进行深拷贝，防止在rowSelectionChange事件中对selectedRowKeys和selectedRows进行修改时影响内部数据
      this.$emit('rowSelectionChange', {
        selectedRowKeys: _.cloneDeep(this.selectedRowKeys),
        selectedRows: _.cloneDeep(this.selectedRows),
        selectedTree
      });
    },
    // ! 表格选择逻辑 End

    /**
     * @description: 滚动到data-row-key的值为rowKey的行
     * @param {String} rowKey rowKey属性对应的值，如果有值，则使用该值，否则使用index
     * @param {Number|undefined} index 需要滚动到的行索引号
     * 在父组件通过this.$refs.basisTable.scrollTo(rowKey,index)的方式调用
     */
    scrollTo(rowKey, index = undefined) {
      setTimeout(() => {
        if (rowKey) {
          const el = this.$refs.aTable.$el.querySelectorAll('tr');
          const rowKeys = [];
          el.forEach(item => {
            if (item.style.display !== 'none') rowKeys.push(item.dataset.rowKey);
          });
          index = rowKeys.findIndex(key => key === rowKey.toString());
        }
        index = index < 1 ? 1 : index;

        // -8 上方保留8px的距离
        this.$refs.aTable.$el.querySelector('.ant-table-body').scrollTop = (index - 1) * this.trHeight - 8;
      }, 300);
    },
    // 可控的筛选 Begin
    // 点击“确定”按钮
    // eslint-disable-next-line max-statements
    async handleSearch(selectedKeys = [], confirm, column) {
      confirm();

      // TODO: 如果需要实现搜索条件的且操作，还需另外实现。可通过指定的prop进行自定义处理
      // 清空其他搜索值
      await this.clearFilters();
      // eslint-disable-next-line no-nested-ternary
      const searchText = column.filters ? selectedKeys : Array.isArray(selectedKeys) ? selectedKeys[0] : selectedKeys;
      this.searchTextMap[column.dataIndex] = searchText;
      this.filteredInfo[column.dataIndex] = selectedKeys;
      if (!this.hasChildren) return;

      // 下方逻辑专门实现树形结构的筛选
      const {
        treeConfig,
        targetDataSourceRaw
      } = this;
      const rawData = _.cloneDeep(targetDataSourceRaw);

      // 没有搜索值
      if (_.isEmpty(searchText)) {
        this.expandedKeys = this.expandedRowKeys || [];
        setTimeout(() => this.targetDataSource = rawData, 0);
        return;
      }
      const nodes = this.$m.tree.findPathAll(rawData, node => {
        // 被匹配的原始值
        const source = node[column.dataIndex]?.toString().toLowerCase() || undefined; // 设为undefined，避免空字符串的也符合条件
        // 需要匹配的目标值
        const target = searchText.toString().trim().toLowerCase() || undefined; // 设为undefined，避免空字符串的也符合条件
        return source && source.includes(target) || target && target.includes(source);
      }, treeConfig) || [];

      // _.flatten展平数组 _.uniq数组去重
      const targetNodes = _.uniq(_.flatten(nodes).map(_item => _item[treeConfig.id]));

      // 没有符合搜索条件的数据
      if (targetNodes.length === 0) {
        this.expandedKeys = this.expandedRowKeys || [];
        this.targetDataSource = [];
        return;
      }

      // 删除不符合条件的数据
      this.$m.tree.removeNode(rawData, node => !targetNodes.includes(node[treeConfig.id]), treeConfig);
      // 默认展开10个，避免卡顿
      this.expandedKeys = targetNodes.slice(0, 10) || [];
      // setTimeout 确保表格能正常展开相应的行
      setTimeout(() => this.targetDataSource = rawData, 0);
    },
    // 重置筛选条件
    handleReset(clearFilters, column) {
      clearFilters();
      this.searchTextMap[column.dataIndex] = column.filters ? [] : '';
      const _expandedKeys = _.merge(this.value || [], this.defaultExpandedRowKeys || [], this.expandedKeys || []);
      this.expandedKeys = _expandedKeys.slice(0, 10);
      this.targetDataSource = _.cloneDeep(this.targetDataSourceRaw);
    },
    // 注：供外部使用，不可修改名称和入参
    clearFilters() {
      return new Promise(resolve => {
        // 延时操作，确保数据已经清空完成
        this.$nextTick(() => {
          const {
            searchTextMap,
            filteredInfo
          } = this;
          Object.keys(searchTextMap).map(key => searchTextMap[key] = Array.isArray(searchTextMap[key]) ? [] : null);
          Object.keys(filteredInfo).map(key => filteredInfo[key] = null);
          resolve();
        });
      });
    },
    // 注：供外部使用，不可修改名称和入参
    clearAll() {
      this.sortedInfo = null;
      this.clearFilters();
    }
    // 可控的筛选 End
  }
};